export function openSMSEditor (phone, message) {
  let smsLink = 'sms:' + phone
  if (message) {
    smsLink += '?body=' + encodeURIComponent(message)
  }
  window.location.href = smsLink
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/sms-editor.js